<template>
  <v-modal
    ref="reportModal"
    :classes="'auth-ui-modal is-wide'"
  >
    <span slot="header-title">{{ $t('admin.magicLinkReportTitle') }}</span>
    <div slot="body">
      <div class="auth-ui-column-container is-left-aligned has-margin-bottom">
        <h2 class="auth-ui-report-heading">
          {{ $t('admin.magicLinkReportMailingListTitle') }}
        </h2>
        <div>
          <span class="auth-ui-report-bolded-text">
            {{ $t('admin.magicLinkReportNameTitle') }}
          </span>
          {{ mailingList.name }}
        </div>
        <div>
          <span class="auth-ui-report-bolded-text">
            {{ $t('admin.magicLinkReportContactsCountTitle') }}
          </span>
          {{ mailingList.contact_count }}
        </div>
        <div>
          <span class="auth-ui-report-bolded-text">
            {{ $t('admin.magicLinkReportIdTitle') }}
          </span>
          {{ mailingList.id }}
        </div>
      </div>
      <div class="auth-ui-column-container is-left-aligned">
        <h2 class="auth-ui-report-heading">
          {{ $t('admin.magicLinkReportViewTitle') }}
        </h2>
        <div class="auth-ui-column-container is-left-aligned auth-ui-report-wrapper">
          <div
            v-for="(report, index) in mailingList.reports"
            :key="mailingList.name + 'report-' + index"
            class="auth-ui-column-container is-left-aligned auth-ui-report-container"
          >
            <div>
              <span class="auth-ui-report-bolded-text">
                {{ $t('admin.magicLinkReportViewStatusTitle') }}
              </span>
              <span
                v-if="report.status === 'Success'"
                class="auth-ui-message help is-success"
              >
                {{ $t('admin.magicLinkReportViewStatus' + report.status) }}
              </span>
              <span
                v-else-if="report.status === 'PartialSuccess'"
                class="auth-ui-message help is-warning"
              >
                {{ $t('admin.magicLinkReportViewStatus' + report.status) }}
              </span>
              <span
                v-else-if="report.status === 'Failure'"
                class="auth-ui-message help is-danger"
              >
                {{ $t('admin.magicLinkReportViewStatus' + report.status) }}
              </span>
              <span v-else>
                {{ $t('admin.magicLinkReportViewStatusUnknown') }}
              </span>
            </div>
            <div>
              <span class="auth-ui-report-bolded-text">
                {{ $t('admin.magicLinkReportViewSTemplateIdTitle') }}
              </span>
              {{ report.templateId ?
                report.templateId : $t('admin.magicLinkMailingListTemplateDefault') }}
            </div>
            <div>
              <span class="auth-ui-report-bolded-text">
                {{ $t('admin.magicLinkReportViewSContactsCountTitle') }}
              </span>
              {{ report.contactsCount }}
            </div>
            <div
              v-if="report.errorData"
              class="auth-ui-column-container is-left-aligned"
            >
              <span v-if="report.errorData.failedEmailsNumber > 0">
                <span class="auth-ui-report-bolded-text">
                  {{ $t('admin.magicLinkReportViewFailedAddressesTitle') }}
                </span>
                {{ report.errorData.failedEmailsNumber }}
                {{ $t('admin.magicLinkReportViewFailedEmailsDescription') }}
                &nbsp;
                <span v-if="report.errorData.failedBatches.length">
                  {{ $t('admin.magicLinkReportViewFailedEmailsOverlapDescription') }}
                </span>
                <span v-if="report.errorData.failedEmailsNumber <= 1000">
                  {{ $t('admin.magicLinkReportViewFailedAddressesTitle') }}
                  {{ report.errorData.failedEmails.join(', ') }}.
                </span>
                <span v-else>
                  {{ $t('admin.magicLinkReportViewFailed1000AddressesTitle') }}
                  {{ report.errorData.failedEmails.join(', ') }}.
                </span>
              </span>
              <span v-if="report.errorData.failedBatches.length">
                <span class="auth-ui-report-bolded-text">
                  {{ $t('admin.magicLinkReportViewFailedBatchesTitle') }}
                </span>
                {{ report.errorData.failedBatches.join(', ') }}.
                {{
                  $t('admin.magicLinkReportViewFailedBatchesDescription',
                     { number: report.batchSize })
                }}
              </span>
            </div>
            <div>
              <span class="auth-ui-report-bolded-text">
                {{ $t('admin.magicLinkReportViewTimeTitle') }}
              </span>
              {{ translateDate(report.time) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-modal>
</template>

<script>
/* ============
   * Mailing List Send Report Modal Component
   * ============
   *
   * Shows report data about adding a mailing list to a
   * magic link send queue.
   *
   * Used by one of the tabs of the "Mail Sends" component,
   * "Send one Time Links Mailing List" component.
   *
   */
import VModal from '@/components/Modal.vue';
import TimeTool from '@/tools/TimeTool';

export default {
  name: 'MailingListSendReport',

  components: {
    VModal,
  },

  data() {
    return {
      mailingList: {
        name: '',
        contact_count: 0,
        id: '',
        reports: [
          { status: '', time: '' },
        ],
      },
    };
  },

  methods: {
    toggleModal(mailingList) {
      this.$forceUpdate(); // needed to update data()
      this.mailingList = mailingList;
      this.$refs.reportModal.toggleModal();
    },

    /**
     * Translates the given date with the correct locale and options.
     */
    translateDate(date) {
      return TimeTool.translateDate(date);
    },
  },
};
</script>
